exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multi-upload[data-v-1b7fc03c]{display:flex;align-items:center}", ""]);

// exports
